import { Icons } from "components";
import { EmptyStateStyled } from "./styled";

const EmptyState = ({ icon, title, subTitle }) => (
  <EmptyStateStyled>
    <div className="empty_icon">{icon || <Icons.Building4 />}</div>
    <div className="empty_title">{title}</div>
    {subTitle && <div className="empty_sub">{subTitle}</div>}
  </EmptyStateStyled>
);

export default EmptyState;
